// extracted by mini-css-extract-plugin
export var border = "_2c-8";
export var brand = "_2c-t";
export var button = "_2c-l";
export var center = "_2c-a";
export var centered = "_2c-6";
export var closeButton = "_2c-c";
export var disabledWrapper = "_2c-m";
export var error = "_2c-p";
export var extraLarge = "_2c-4";
export var extraSmall = "_2c-1";
export var fill = "_2c-i";
export var footer = "_2c-h";
export var footerAction = "_2c-j";
export var footerButtons = "_2c-k";
export var header = "_2c-7";
export var headerWithClose = "_2c-d";
export var icon = "_2c-o";
export var info = "_2c-s";
export var inline = "_2c-9";
export var large = "_2c-3";
export var main = "_2c-e";
export var modal = "_2c-0";
export var nearFull = "_2c-5";
export var neutral = "_2c-u";
export var noPadding = "_2c-g";
export var none = "_2c-v";
export var scrollable = "_2c-f";
export var small = "_2c-2";
export var success = "_2c-r";
export var tight = "_2c-n";
export var titleIcon = "_2c-b";
export var warn = "_2c-q";